import { render, staticRenderFns } from "./articleCategorySearch.vue?vue&type=template&id=30132aa8&"
import script from "./articleCategorySearch.vue?vue&type=script&lang=js&"
export * from "./articleCategorySearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports